import { connect } from 'react-redux';

import commonMapDispatchToProps from '../../../../../../../container/commonMapDispatchToProps';
import commonMapStateToProps from '../../../../../../../container/commonMapStateToProps';
import {
  doRetrieveSolutionContent,
  largeCuratedAddonsRenderComplete,
  largeCuratedAddonsRenderStarted,
  smallCuratedAddonsRenderComplete,
  smallCuratedAddonsRenderStarted,
} from '../../../actions/Solutions';
import Solution from '../components/Solution';

function mapStateToProps(state: any) {
  return {
    ...commonMapStateToProps(state),
    config: state.solutions.config,
    addonDiscoveryConfig: state.addonDiscovery.config,
    solutionContent: state.solutions.solutionContent,
    isCuratedAddonsRenderComplete:
      state.solutions.isLargeCuratedAddonsRenderComplete &&
      state.solutions.isSmallCuratedAddonsRenderComplete,
  };
}

const mapDispatchToProps = (dispatch: any) => {
  return {
    ...commonMapDispatchToProps(dispatch),
    retrieveSolutionContent:
      ({ commonConfig }) =>
      ({ solutionKey }) => {
        dispatch(doRetrieveSolutionContent({ solutionKey, commonConfig }));
      },
    onLargeCuratedAddonsRenderComplete() {
      dispatch(largeCuratedAddonsRenderComplete());
    },
    onLargeCuratedAddonsRenderStarted() {
      dispatch(largeCuratedAddonsRenderStarted());
    },
    onSmallCuratedAddonsRenderComplete() {
      dispatch(smallCuratedAddonsRenderComplete());
    },
    onSmallCuratedAddonsRenderStarted() {
      dispatch(smallCuratedAddonsRenderStarted());
    },
  };
};

const mergeProps = (stateProps: any, dispatchProps: any, ownProps: any) => {
  return {
    ...ownProps,
    ...stateProps,
    ...dispatchProps,
    retrieveSolutionContent: dispatchProps.retrieveSolutionContent({
      commonConfig: stateProps.commonConfig,
    }),
  };
};

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(Solution);
